<template>
  <section
    class="my-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-8 shadow-black shadow-xl max-w-[1400px] font-helvetica text-[#999999]"
  >
    <h2 class="text-white text-2xl md:text-3xl font-russo pb-4">
      Frequently Asked Questions
    </h2>
    <div class="flex flex-col divide-y divide-[#333]">
      <div v-for="(item, i) in faqs" :key="i" class="py-4">
        <h3 class="text-white font-russo text-[18px] md:text-[20px] pb-2">
          {{ item.q }}
        </h3>
        <p class="text-[15px] md:text-[17px] font-semibold">{{ item.a }}</p>
      </div>
    </div>
  </section>
</template>

<script>
const FAQS = [
  {
    q: 'What Is a Rally Roadbook?',
    a: 'A rally roadbook is a turn-by-turn navigation document that a rally crew follows during an event. Each waypoint shows the distance to the next instruction, a tulip diagram of the junction, a compass heading, and icons or notes warning of hazards and landmarks.',
  },
  {
    q: 'What Is Rally Navigator?',
    a: 'Rally Navigator is desktop software for creating professional, FIA-compliant rally roadbooks. You design your route on a map, and it captures distances and headings, draws tulip diagrams, and prints a finished roadbook to PDF or exports an OpenRally GPX file.',
  },
  {
    q: 'Is Rally Navigator Free?',
    a: 'Rally Navigator offers a free 7-day trial with all Premium and Pro features, including PDF and GPX export. Free-tier roadbooks are limited to 25 km or 25 waypoints; Premium and Pro subscriptions remove the limit.',
  },
  {
    q: 'Does Rally Navigator Create FIA-Compliant Roadbooks?',
    a: 'Yes. Rally Navigator lays out print-ready roadbook pages that meet FIA and FIM roadbook specifications, with the full library of FIA and Dakar navigation icons.',
  },
  {
    q: 'What Roadbook Formats Can I Export?',
    a: 'You can print roadbooks to PDF in A4, A5, Letter, Legal, and continuous moto-roll formats, and export an OpenRally GPX file with scoring and control data for your timing system.',
  },
  {
    q: 'What Platforms Does Rally Navigator Run On?',
    a: 'Rally Navigator runs on Windows, macOS, and Linux. Roadbooks can also be viewed on the Rally Roadbook Reader mobile app for iOS and Android.',
  },
];

const LD_ID = 'faq-jsonld';

export default {
  name: 'FaqSection',
  data() {
    return { faqs: FAQS };
  },
  mounted() {
    if (document.getElementById(LD_ID)) return;
    const ld = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    };
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = LD_ID;
    el.textContent = JSON.stringify(ld);
    document.head.appendChild(el);
  },
  unmounted() {
    const el = document.getElementById(LD_ID);
    if (el) el.remove();
  },
};
</script>

<style scoped></style>
